import Relay from 'react-relay';

import ClientNetworkLayer from 'depop/relay/ClientNetworkLayer';

import { config } from 'depop/config';

let envCounter = 0;


export default function getEnvironment() {
  const environment = new Relay.Environment();

  environment.injectNetworkLayer(new ClientNetworkLayer(config.graphql_url, {
    credentials: 'same-origin',
  }));

  environment.id = envCounter;
  envCounter++;

  return environment;
}



// WEBPACK FOOTER //
// ../src/client/getEnvironment.js